import { US_state } from "../../cohorts/UtilFileForCohort/getCohortSupportData";

export type StatusRefinementItem = {
  value: string;
  label: string;
  count: number;
  isRefined: boolean;
};

export const STATUS_ORDER: string[] = [
  "active",
  "pending",
  "dormant",
  "closed",
  "removed",
];

export const getInitials = (name?: string) => {
  if (!name) return "NA";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const formatDate = (value: any) => {
  if (!value) return "No history";
  if (typeof value === "number") return new Date(value).toLocaleDateString();
  if (typeof value === "string") return new Date(value).toLocaleDateString();
  if (typeof value === "object" && value.seconds) {
    return new Date(value.seconds * 1000).toLocaleDateString();
  }
  return "No history";
};

export const getMilAffiliation = (hit: any) => {
  if (hit?.claims?.milspouse) return "Military spouse";
  if (hit?.claims?.militaryConnected) return "Active duty";
  if (hit?.claims?.veteran) return "Veteran";
  if (hit?.claims?.familyMember) return "Family member";
  return "-";
};

export const AFFILIATION_LABEL_MAP: Record<string, string> = {
  FM: "Family Member",
  S: "Military Spouse",
  V: "Veteran",
  R: "Military Retired",
};

export const getAffiliationLabel = (raw: string): string =>
  AFFILIATION_LABEL_MAP[raw] || raw;

export const getLocation = (hit: any) =>
  hit?.location ||
  [hit?.city, US_state[hit?.address?.state as keyof typeof US_state]]
    .filter(Boolean)
    .join(", ") ||
  "-";
